// The Dreamboard's mosaic on a wide screen (Craig, 4 Nov 2026: "tiles organize and nest such that there is no blank
// space between them… stay reasonably close to each other based on the 'list-based' sort order"). Three columns (two
// below MOSAIC_THREE_MIN, where three would be narrower than a phone's card); the
// grid places each card in reading order into the first place it fits, so a card slides up under a shorter one instead
// of waiting for the row to end. Rows are ROW px tall and each card spans as many as its height needs.
export const MOSAIC_THREE_MIN = 1100;
export const MOSAIC_ROW = 4;
export const MOSAIC_GAP = 12;

// How many rows a card `height` px tall spans, with the gap below it.
export const mosaicSpan = (height) => Math.max(1, Math.ceil((height + MOSAIC_GAP) / MOSAIC_ROW));

// A photo's shape (width over height) in the mosaic: its own, kept between a tall portrait (3:4) and a wide landscape
// (16:9), so no card becomes a sliver or a tower.
export const photoRatio = (width, height) => {
  if (!width || !height) return 4 / 3;
  return Math.min(16 / 9, Math.max(3 / 4, width / height));
};
